import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Card, PageHeader } from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import SmartviewButton from 'widgets/smartviews/SmartviewButton'
import { Collection } from '@morningtrain/react-resources'
import { EnumFilter, SearchFilter, SelectedDepartmentFilter } from 'support/filters'
import { TableHeader } from 'ui/table'
import { Table } from 'widgets/crud'
import MountSmartviewOnClickTableRow from 'widgets/crud/MountSmartviewOnClickTableRow'
import * as Columns from 'support/columns'
import { PaginationFilter } from '@morningtrain/react-filters'
import ViewMessageSmartview from 'widgets/smartviews/hr/messages/ViewMessageSmartview'

export default function Messages () {
  return (
    <AdminPageWithSmartview>
      <Translator namespace='hr.messages'>

        {/* Page header */}
        <PageHeader title={<TranslatedTitle name='title'/>}>
          <SmartviewButton smartview={<ViewMessageSmartview/>}>
            <Translation name='actions.create'/>
          </SmartviewButton>
        </PageHeader>

        <Card>
          <Collection resourceName='messages.messages'>
            <TableHeader>
              <SelectedDepartmentFilter/>
              <EnumFilter
                enum='message_type'
                name='type'
                placeholder='-'
                label={<Translation name='filters.message_type.label'/>}
              />
              <EnumFilter
                enum='message_status'
                name='status'
                placeholder='-'
                label={<Translation name='filters.status.label'/>}
              />
              <SearchFilter
                label={<Translation name='filters.search.label'/>}
              />
            </TableHeader>
            <Table row={<MountSmartviewOnClickTableRow smartview={<ViewMessageSmartview/>}/>}>
              <Columns.DateTime
                name='created_at'
                label={<Translation name='columns.created_at.label'/>}
              />
              <Columns.Text
                name='subject'
                label={<Translation name='columns.subject.label'/>}
              />
              <Columns.Enum
                name='type'
                enum='message_type'
                label={<Translation name='columns.type.label'/>}
              />
              <Columns.Boolean
                name='is_forced'
                label={<Translation name='columns.is_forced.label'/>}
              />
              <Columns.Enum
                name='status'
                enum='message_status'
                label={<Translation name='columns.status.label'/>}
              />
              <Columns.Text
                name='author.name'
                label={<Translation name='columns.author.label'/>}
              />
            </Table>
            <PaginationFilter/>
          </Collection>
        </Card>
      </Translator>
    </AdminPageWithSmartview>
  )
}
